// ageとlifeをtoNumber, svgのscriptチェック, invalid codepoint例外のチェック
export default async function safeGetParams(contract, tokenId) {
    try {
        const params = await contract.getParams(tokenId);
        // #14はここで例外発生 (invalid codepoint at offset)
        const { name, svg, isAlive, age, life } = params;
        // svgにscriptタグが含まれていたらerror
        // if (new RegExp("<script", "i").test(svg)) {
        // nameに<が含まれていたらerror → <script>, <a href="javascript:～">など
        if (name.includes("<")) {
            return { error: "Invalid SVG" };
        } else {
            return {
                name,
                svg,
                isAlive,
                age: age.toNumber(),
                life: life.toNumber(),
            };
        }
    } catch (error) {
        return { error: error.message };
    }
}
